<template>
  <div class="zebra-grid">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "ZebraGrid"
});
</script>

<style lang="scss">
.zebra-grid {
  // The grid uses a four-column layout.
  // The middle column is not used for content,
  // but to take space when resizing the popup.
  position: relative;
  display: grid;
  grid-template-columns: fit-content(50rem) 1fr fit-content(10rem) auto;
  grid-auto-rows: minmax(1rem, max-content);
  align-items: stretch;

  margin-right: -1rem;
  margin-left: -1rem;

  width: max-content;
  min-width: calc(100% + 2rem);
  max-width: calc(100% + 2rem);

  & > * {
    // all direct children of the grid are used as grid cells.
    overflow: hidden;
    text-overflow: ellipsis;

    &:nth-child(4n + 1),
    &:nth-child(4n + 4) {
      padding: 0.25rem 0.5rem;
    }

    &:nth-child(4n + 1) {
      padding-left: 1rem;
    }

    &:nth-child(4n + 3) {
      padding: 0.25rem 0.25rem;
      text-align: right; // align right on the number column
    }
    &:nth-child(4n + 4) {
      padding-right: 1rem;
      padding-left: 0;
    }

    &:nth-child(8n + 1),
    &:nth-child(8n + 2),
    &:nth-child(8n + 3),
    &:nth-child(8n + 4) {
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
}
</style>
